<template>
  <div>
    <div class="mt-5">
      <b-container fluid>
        <div class="card mb-1">
          <div class="card-body py-2 px-3">
            <div class="row">
              <div class="col">
                <div class="form-group m-0 p-0">
                  <label>Select Session</label>
                  <select
                    class="form-control form-control-sm"
                    v-model="session"
                    @change="loadPayments"
                  >
                    <option v-for="(s, index) in sessionOptions" :key="index">
                      {{ s }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col">
                <div class="form-group m-0 p-0">
                  <label>Payment Type</label>
                  <select
                    class="form-control form-control-sm"
                    v-model="paymentType"
                    @change="loadPayments"
                  >
                    <option value="">All</option>
                    <option value="school fees">School Fees</option>
                    <option value="special payment">Special Payment</option>
                  </select>
                </div>
              </div>
              <div class="col">
                <div class="form-group m-0 p-0">
                  <label>Payment Status</label>
                  <select
                    class="form-control form-control-sm"
                    v-model="paymentStatus"
                    @change="loadPayments"
                  >
                    <option value="">All</option>
                    <option value="SUCCESS">SUCCESS</option>
                    <option value="PENDING">PENDING</option>
                  </select>
                </div>
              </div>
              <div class="col">
                <div class="form-group m-0 p-0">
                  <label>Degree</label>
                  <select
                    class="form-control form-control-sm"
                    v-model="degree"
                    @change="loadPayments"
                  >
                    <option value="">All</option>
                    <option
                      v-for="(d, index) in degreeOptions"
                      :key="index"
                      :value="d.programme_type"
                    >
                      {{ d.programme_type }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col">
                <div class="form-group m-0 p-0">
                  <label>Programme</label>
                  <select
                    class="form-control form-control-sm"
                    v-model="programme"
                    @change="loadPayments"
                  >
                    <option value="">All</option>
                    <option
                      v-for="(p, index) in programmeOptions"
                      :key="index"
                      :value="p.id"
                    >
                      {{ p.programme }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-end mb-2  align-items-center gap-2">
          <div class="input-group" style="max-width: 350px;">
            <input
              v-model="searchQuery"
              @keyup.enter="searchPayments"
              type="text"
              class="form-control form-control-sm"
              placeholder="Search by Email or Matric No"
            />
            <div class="input-group-append">
              <button class="btn btn-primary btn-sm" @click="searchPayments">
                <i class="fas fa-search"></i> Search
              </button>
            </div>
          </div>
          <button class="btn btn-info" @click="downloadPayments">
            <i class="fas fa-download"></i> Download
          </button>
        </div>

        <template v-if="items.length > 0">
          <b-table
            :busy="isBusy"
            :items="items"
            :fields="fields"
            :key="tableKey"
            :filter="filter"
            :filter-included-fields="filterOn"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            stacked="md"
            show-empty
            small
            @filtered="onFiltered"
            hover
            @row-clicked="onRowClicked"
            :row-class="() => 'clickable-row'"
          >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
            <template #cell(date_paid)="{ value }">
              {{ formatDate(value) }}
            </template>
          </b-table>
        </template>
        <template v-else>
          <div class="text-center text-muted my-4">
            <strong>No records found for the selected filters.</strong>
          </div>
        </template>
        <PaymentDetailsModal
          :show="showDetailsModal"
          :payment="selectedPayment"
          @update:show="showDetailsModal = $event"
        />

        <b-row>
          <b-col md="6" class="my-1">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              class="my-0"
            ></b-pagination>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import PaymentDetailsModal from "./PaymentDetailsModal.vue";
function pad(n) {
  return n < 10 ? "0" + n : n;
}
export default {
  data() {
    return {
      isBusy: false,
      items: [],
      downloadBusy: false,
      showDetailsModal: false,
      selectedPayment: null,
      searchQuery: "",
      fields: [
        { key: "sn", label: "ID", sortable: true },
        { key: "name", label: "Student Name", sortable: true },
        { key: "matric_number", label: "Matric No", sortable: true },
        { key: "programme", label: "Programme", sortable: true },
        { key: "email", label: "Email", sortable: true },
        { key: "rrr", label: "RRR", sortable: true },
        { key: "amount", label: "Amount", sortable: true },
        { key: "degree", label: "Degree", sortable: true },
        { key: "session", label: "Session", sortable: true },
        { key: "type", label: "Type", sortable: true },
        { key: "status", label: "Status", sortable: true },
        { key: "date_paid", label: "Date", sortable: true },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      session: "",
      paymentType: "",
      paymentStatus: "",
      degree: "",
      programme: "",
      tableKey: 0,
    };
  },
  computed: {
    ...mapState({ settings: (state) => state.settings }),
    sortOptions() {
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
    paginatedItems() {
      return this.items;
    },
    sessionOptions() {
      // Extract session names from Vuex settings
      if (!this.settings || !this.settings.length) return [];
      return [...new Set(this.settings.map((s) => s.session_name))];
    },
    degreeOptions() {
      return this.$store.state.programmeTypes || [];
    },
    programmeOptions() {
      return this.$store.state.programmes || [];
    },
  },
  mounted() {
    this.loadPayments();
  },
  created() {
    this.$store.dispatch("getSettings");
    this.$store.dispatch("getprogrammeTypes");
    this.$store.dispatch("getProgrammes");
  },
  methods: {
    onRowClicked(payment) {
      this.selectedPayment = payment;
      this.showDetailsModal = true;
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    formatDate(dateStr) {
      if (!dateStr) return "";
      const d = new Date(dateStr);
      if (isNaN(d.getTime())) return dateStr;
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
        d.getDate(),
      )} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    },
    loadPayments() {
      this.isBusy = true;
      let params = {};
      if (this.session) params.session = this.session;
      if (this.paymentType) params.payment_type = this.paymentType;
      if (this.paymentStatus) params.status = this.paymentStatus;
      if (this.degree) params.degree = this.degree;
      if (this.programme) params.programme = this.programme;
      params.page = this.currentPage;
      // If searchQuery is present, add it to params
      if (this.searchQuery) {
        params.search = this.searchQuery;
      }
      axios
        .get("https://pgr.run.edu.ng/admin/load_all_student_payments", {
          params,
        })
        .then((response) => {
          this.isBusy = false;
          this.items = [];
          this.totalRows = 0;
          if (
            response.data.success === false ||
            !response.data.data ||
            !response.data.data.length
          ) {
            this.items = [];
            this.totalRows = 0;
            this.tableKey++;
            console.log(
              "No records: items",
              this.items,
              "tableKey",
              this.tableKey,
            );
          } else {
            this.items = response.data.data;
            if (!this.session && this.sessionOptions.length) {
              this.session = this.sessionOptions[0];
            }
            if (
              response.data.meta &&
              response.data.meta.per_page &&
              response.data.count
            ) {
              this.totalRows = response.data.count;
              this.perPage = response.data.meta.per_page;
            } else {
              this.totalRows = this.items.length;
            }
            this.tableKey++;
            console.log(
              "Records found: items",
              this.items,
              "tableKey",
              this.tableKey,
            );
          }
        })
        .catch(() => {
          this.isBusy = false;
          this.items = [];
          this.totalRows = 0;
          this.tableKey++;
          console.log("Error: items", this.items, "tableKey", this.tableKey);
        });
    },
    searchPayments() {
      this.currentPage = 1;
      this.loadPayments();
    },
    downloadPayments() {
      this.downloadBusy = true;
      // Build params from current filters
      let params = {};
      if (this.session) params.session = this.session;
      if (this.paymentType) params.payment_type = this.paymentType;
      if (this.paymentStatus) params.status = this.paymentStatus;
      if (this.degree) params.degree = this.degree;
      if (this.programme) params.programme = this.programme;
      if (this.searchQuery) {
        params.search = this.searchQuery;
      }
      // You may need to adjust the endpoint below to match your backend
      axios({
        url: "https://pgr.run.edu.ng/admin/download_student_payments",
        method: "GET",
        params,
        responseType: "blob",
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "student-payments.csv");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch(() => {
          this.$bvToast &&
            this.$bvToast.toast("Download failed", {
              variant: "danger",
              title: "Error",
            });
        })
        .finally(() => {
          this.downloadBusy = false;
        });
    },
  },
  components: {
    PaymentDetailsModal,
  },
  watch: {
    session() {
      this.currentPage = 1;
      this.loadPayments();
    },
    currentPage() {
      this.loadPayments();
    },
    // Only one watcher for showDetailsModal is needed
    showDetailsModal(val) {
      if (!val) {
        this.selectedPayment = null;
      }
    },
    searchPayments() {
      this.currentPage = 1;
      this.selectedPayment = null;
      this.showDetailsModal = false;
      this.loadPayments();
    },
  },
};
</script>

<style>
.clickable-row {
  cursor: pointer;
}

.gap-2 {
  gap: 0.8rem; /* or 1rem for more space */
}
</style>
